<template>
  <div>
    <div class="flex mt-4" v-if="!isComboDeal" >
      <div class="w-full text-center"
      >
        <p
          :class="[
            'text-xl font-bold text-gray-700 additionTitle border-b-1 my-6' /*, theme.AdditionsPopUp.HeadertextColor*/,
          ]"
          :style="makeStyles(kioskAdditionTitleLine , kioskAdditionTitleColor)"
        >
          <span class="px-6 text-2xl"
          :style="{
            background: modifierTitleBackground
          }">{{
            modifier[`name_${language}`]
          }}</span>
        </p>
        <p
          v-if="modifier.minSelectedAmount"
          class="text-sm -mt-3 mb-2 requiredTitle"
        >
          {{lang["required"][language]}}
        </p>
      </div>

      <div class="ml-2 w-12 flex flex-col justify-center">
        <p v-if="modifier.minSelectedAmount" class="text-xs whitespace-no-wrap">
          {{ lang["minimum_addition_selection"][language] }}:
          {{ modifier.minSelectedAmount }}
        </p>
        <p 
          v-if="modifier.maxSelectedAmount > 0" 
          ref="maxSelectedAmountText" 
          class="text-xs whitespace-no-wrap"   
          :class="{
            'text-red-500 font-bold': selectedModifiersArray.length === modifier.maxSelectedAmount
          }"
              :style="{
      color: selectedModifiersArray.length === modifier.maxSelectedAmount ? '' : modifierMaxTextColor
    }"
        >
          {{ lang["maximum_addition_selection"][language] }}:
          {{ modifier.maxSelectedAmount }}
        </p>
      </div>
    </div>
    <div></div>
    <div
      :class="[
        ' rounded-xl mt-2 borderlastChild grid grid-cols-3 gap-8',
        modifier.Additions.length > 5 && !hasKiosk
          ? 'blueScroll h-48 scrollbar-thin scrollbar-track-primary-100 overflow-y-scroll scrollbar-thumb-rounded'
          : '',
        modifier.Additions.length > 5 &&
        CurrentTheme == 'default' &&
        !hasKiosk
          ? 'scrollbar-thumb-primary'
          : 'scrollbar-thumb-new-primary',
        menu.layout == 'frydate' ? 'font-sans' : '',
      ]"
    >
      <label
        v-if="addition.isVisible"
        :class="[
          'borderlastChild w-full',
          addition.picture_url ? 'borderBottomNone' : 'borderNone',
        ]"
        v-for="addition in modifier.Additions"
        :id="addition.Id"
        :key="addition.Id"
      >
        <div class="rounded-xl w-full overflow-hidden" :style="makeStyles(itemAdditionsRadius , kioskModifierItemBorder, 
        (selectedModifiersArray.includes(addition.Id)
                ? listsActiveBackground
                : listsBackground))">
          <div
            :class="[
              'flex justify-center text-center cursor-pointer AdditionItemWrapper AdditionItemWrapper--open',
              menu.is_kiosk_full_picture ? '' : 'rounded-t-xl',
            ]"
            v-if="addition.picture_url"
          >
            <Picture
              class="additionsPicture"
              :src="addition.picture_url"
              alt
              :class="['rounded-t-xl h-24 md:w-full object-cover']"
              keepRatio
            />
          </div>
          <input
            @click="clickedOnModifier($event, addition, modifier)"
            v-model="selectedModifiers"
            class="mr-2 leading-tight input w-full hidden"
            :type="modifier.maxSelectedAmount == 1 ? 'radio' : 'checkbox'"
            :value="addition"
            :name="modifier[`name_${language}`]"
          />
          <div
            :class="{'pr-4 py-2 flex justify-between p-2 pl-6 activeColorRadius h-16 items-center':true,'shadow': modifierShadowEnabled}"
            :key="selectedModifiersArray.join()"
            :style="makeStyles(itemAdditionsRadius ,
              (selectedModifiersArray.includes(addition.Id)
                ? listsActiveBackground + listActivePriceBorder
                : listsBackground))
            "
          >
            <div :class="[' items-center flex']">
              <div class="block">
                <span
                  :class="[
                    'font-semibold',
                    { active: isActive }
                  ]"
                  :style="
                    selectedModifiersArray.includes(addition.Id)
                      ? listsActiveText
                      : listsText
                  "
                  >{{ addition[`name_${language}`] }} </span
                >
                <p
                  v-if="addition.price > 0"
                  class="text-sm font-semibold pr-1"
                  :style="
                    selectedModifiersArray.includes(addition.Id)
                      ? listsActiveText
                      : listsText
                  "
                >
                  {{ currency }} {{ addition.price }}
                </p>
              </div>
            </div>

            <div class="flex">
              <div style="listsBackground">
                <label v-if="addition.price > 0">
                  <input
                    @click="clickedOnModifier($event, addition, modifier)"
                    v-model="selectedModifiers"
                    class="mr-2 leading-tight input hidden"
                    :type="
                      modifier.maxSelectedAmount == 1 ? 'radio' : 'checkbox'
                    "
                    :value="addition"
                    :name="modifier[`name_${language}`]"
                  />
                  <span
                    :class="[
                      'flex items-center p-1 justify-center rounded-xxl h-auto w-auto border-1 checked extra checkedPrice',
                      disableBackground,
                    ]"
                    :style="
                      selectedModifiersArray.includes(addition.Id)
                        ? listActivePrice + listActivePriceBorder
                        : additionAddBackground
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      class="w-4 h-4"
                    >
                      <path
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        fill="none"
                        :stroke="
                          selectedModifiersArray.includes(addition.Id)
                          ? selectItemActiveColor
                          : selectItemColor
                        "
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </label>
                <span
                  v-if="!addition.price"
                  :class="[
                    'flex items-center p-1 justify-center rounded-xxl h-auto w-auto border-1 checked2',
                    disableBackground,
                  ]"
                  :style="
                    selectedModifiersArray.includes(addition.Id)
                      ? listActivePrice + listActivePriceBorder
                      : '' + additionAddBackground
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    class="w-4 h-4"
                  >
                    <path
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      fill="none"
                      :stroke="
                          selectedModifiersArray.includes(addition.Id)
                          ? selectItemActiveColor
                          : selectItemColor
                        "
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </label>
    </div>
    <transition-group tag="div" name="fade" class="relative" mode="in-out">
      <div key="loader" class="w-full" v-show="isLoading">
        <SkeletonComboAdditionsKiosk />
      </div>
      <div class="w-full" key="comboAdditionsContent" v-show="!isLoading&&Object.keys(currentGroup).length">
        <div
          v-for="(modifierGroup, groupIndex) in categoryModifier"
          :key="modifierGroup.Id"
          class="allComboAdditions w-full"
        >
          <ComboAdditionsKiosk
            :modifier="modifier"
            :groupIndex="groupIndex"
            :modifierGroup="modifierGroup"
            :allSelectedModifiers="allSelectedModifiers"
          />
        </div>
      </div>
    </transition-group>

  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
import _ from "lodash";
import axios from "axios";
import ComboAdditionsKiosk from "./ComboAdditionsKiosk.vue";
import SkeletonComboAdditionsKiosk from "./SkeletonLoaders/SkeletonComboAdditionsKiosk.vue";

export default {
  props: {
    modifiers: {
      type: Array,
      required: true,
    },
    modifier: {
      type: Object,
      required: true,
    },
    isComboDeal: {
      type: Boolean,
      required: true,
    },
    allSelectedModifiers: {
      type: Array,
      required: true,
    },
    arrayNumber: Number,
    defaultSelected: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    ComboAdditionsKiosk,
    SkeletonComboAdditionsKiosk,
  },
  data() {
    return {
      lodash: _,
      lang: lang,
      selectedModifiers: [],
      selectedComboModifiers: [],
      comboDealIndex: 0,
      comboGroupDealIndex: 0,
      // used for saving additions and using them for editing an cart item
      selectedAdditions: [],
      // Temporary to keep the Ids to match with the theme.
      selectedModifiersArray: [],
      disableModifiers: false,
      modifiersMessage: "",
      disableBackground: "",
      isActive: false,
      CurrentTheme: localStorage.getItem("theme"),
      previeusAdditionPrice: 0,
      previeusAdditionId: 0,
      radioButtonLength: false,
      currentGroup: {},
      updatedMinMax: false,
      categoryModifier: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters([
      "menu",
      "itemPrice",
      "language",
      "currency",
      "theme",
      "minSelectedAddition",
      "minSelectedAdditionTotal",
      "minModifiersCheck",
      "menuHash",
      "hasKiosk",
      "minSelectedAdditionComboTotal",
      "minModifierComboCount",
      "comboItemSelectionStep",
    ]),
    ...mapGetters("Cart", ["comboDealAdditions"]),
    ...mapGetters("Theme", [
      "listsText",
      "listsBackground",
      "listsActiveText",
      "listsActiveBackground",
      "btnOutlineBorder",
      "btnOutlineText",
      "btnOutlineBackground",
      "btnOutlineIcon",
      "btnOutlineActiveBorder",
      "btnOutlineActiveText",
      "btnOutlineActiveBackground",
      "btnOutlineActiveIcon",
      "listActivePrice",
      "listActivePriceText",
      "itemAdditionsRadius",
      "selectItemColor",
      "selectItemActiveColor",
      "kioskModifierItemBorder",
      "kioskAdditionTitleLine",
      "listActivePriceBorder",
      "additionAddBackground",
      "kioskAdditionTitleColor",
      "mainSubCategorysBackground",
      "menuSubCategoriesBackground",
      "modifierTitleBackground",
      "modifierMaxTextColor",
      "modifierShadowEnabled"
    ]),
  },
  watch: {
    // watches if the correct amount of modifiers are selected
    selectedModifiers(currentValue) {
      this.currentGroup = currentValue;
      if (
        (this.minModifierComboCount != this.minSelectedAdditionComboTotal &&
          (this.comboDealAdditions.combogroupid ==
            currentValue.AdditionGroupId ||
            (Array.isArray(currentValue) &&
              currentValue.length &&
              currentValue
                .map((el) => el.AdditionGroupId)
                .includes(this.comboDealAdditions.combogroupid)))) ||
        this.minModifierComboCount == 0 ||
        this.minModifierComboCount == this.minSelectedAdditionComboTotal
        // first test it then we can remove this section
        || 1 == 1
      ) {
        this.handleChangeEmit();
        this.selectedComboModifiers = {};
        this.handleSelectedChange(currentValue);
      } else {
        let array = [];
        const comboAdditions = document.querySelectorAll(`.allComboAdditions`);
        comboAdditions.forEach((x) => {
          // for each addition we check if AdditionSelected is added in the classlist. If they have that class we know that the user selected the required additions
          if (!x.classList.contains("AdditionSelected")) {
            // we add the required class to show the red bold text on the kiosk
            x.classList.add("required");
            // we add the animated class to use the animated zoom effect
            x.classList.add("animated");
            // we remove the effect every time so when the user click again the effect will run again
            setTimeout(function () {
              x.classList.remove("animated");
            }, 1600);
            array.push(x);
          } else {
            // we remove the required classname when we already selected an addition
            x.classList.remove("required");
          }
        });
        // we select the first one inside the array to scroll to
        array[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    },
    comboItemSelectionStep(value) {
      if (
        this.modifiers[value].AdditionGroupId ==
        this.selectedModifiers?.AdditionGroupId
      ) {
        this.isLoading = true;
        axios
          .get(
            `${process.env.VUE_APP_API_BASE_PATH}/GetComboDealItemAdditions?MenuHash=${this.menuHash}&AdditionId=${this.selectedModifiers.Id}`
          )
          .then((response) => {
            if (
              (this.minModifierComboCount !=
                this.minSelectedAdditionComboTotal &&
                this.modifier.maxSelectedAmount <= 1 &&
                this.comboDealAdditions.combogroupid ==
                  response.data.combo_group_id) ||
              this.minModifierComboCount == 0 ||
              this.minModifierComboCount == this.minSelectedAdditionComboTotal
            ) {
              this.categoryModifier = response.data.Modifiers;
              let obj = {
                combogroupid: response.data.combo_group_id,
                data: response.data.Modifiers,
              };
              this.$store.commit("Cart/updateComboDealAdditions", obj);
              this.$store.commit("Cart/updateComboDealAdditions", obj);
              if (!response.data.Modifiers.length) {
                this.$store.commit("updateMinModifierComboCount", 0);
              } else {
                let minModifierComboCount = 0;
                response.data.Modifiers.map((x) => {
                  if (
                    (x.minSelectedAmount > 0 && x.maxSelectedAmount > 0) ||
                    (x.minSelectedAmount > 0 && x.maxSelectedAmount == -1)
                  ) {
                    minModifierComboCount++;
                  }
                });
                this.$store.commit(
                  "updateMinModifierComboCount",
                  minModifierComboCount
                );
                let selectedModifiersGroupIds = this.allSelectedModifiers.map(
                  (el) => el.AdditionGroupId
                );
                let minSelectedAdditionComboTotal = 0;
                response.data.Modifiers.forEach((element) => {
                  if (
                    selectedModifiersGroupIds.includes(
                      element.AdditionGroupId
                    ) &&
                    element.minSelectedAmount > 0
                  ) {
                    minSelectedAdditionComboTotal += element.minSelectedAmount;
                  }
                });
                this.$store.commit(
                  "updateMinSelectedAdditionComboTotal",
                  minSelectedAdditionComboTotal
                );
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      }
    },
  },
  methods: {
    clickedOnModifier($event, addition, modifier) {
      if (modifier.maxSelectedAmount > 1 && modifier.maxSelectedAmount && this.selectedModifiersArray.length == modifier.maxSelectedAmount && !this.selectedModifiersArray.includes(addition.Id)) {
       this.triggerShakeAnimation();
        return $event.preventDefault();
      }
      if (this.isComboDeal) {
        /** if already selected then clicked to unselect list and do not call API*/
        if (this.selectedModifiersArray.includes(addition.Id)) {
          this.uncheck(
            $event,
            addition.Id,
            addition.price,
            modifier.AdditionGroupId
          );
        } else {
          this.getComboDealAdditions(modifier, addition);
        }
      } else {
        this.selectModifier(
          modifier.AdditionGroupId,
          addition.price,
          addition.Id,
          { modifier, addition }
        );
      }
      if (!this.isComboDeal && modifier.maxSelectedAmount == 1) {
        this.uncheck($event, addition.Id, addition.price);
      }
    },
    triggerShakeAnimation() {
      const element = this.$refs.maxSelectedAmountText;
      if (element) {
        element.classList.add('shake');
        setTimeout(() => {
          element.classList.remove('shake');
        }, 500); // Duration of the shake animation
      }
    },
    giveComboDealId(index, groupIndex) {
      this.comboDealIndex = index;
      this.comboGroupDealIndex = groupIndex;
    },
    getComboDealAdditions(modifier, addition) {
      let id = addition.Id;
      if (!this.isComboDeal) {
        return;
      }
      this.isLoading = true;
      axios
        .get(
          `${process.env.VUE_APP_API_BASE_PATH}/GetComboDealItemAdditions?MenuHash=${this.menuHash}&AdditionId=${id}`
        )
        .then((response) => {
            this.categoryModifier = response.data.Modifiers;
            let obj = {
              combogroupid: response.data.combo_group_id,
              data: response.data.Modifiers,
            };
            this.$store.commit("Cart/updateComboDealAdditions", obj);
            if (!response.data.Modifiers.length) {
              this.$store.commit("updateMinModifierComboCount", 0);
            } else {
              let minModifierComboCount = 0;
              response.data.Modifiers.map((x) => {
                if (
                  (x.minSelectedAmount > 0 && x.maxSelectedAmount > 0) ||
                  (x.minSelectedAmount > 0 && x.maxSelectedAmount == -1)
                ) {
                  minModifierComboCount++;
                }
              });
              this.$store.commit(
                "updateMinModifierComboCount",
                minModifierComboCount
              );
            }
            this.$store.commit("updateMinSelectedAdditionComboTotal", 0);
            this.$store.commit("deleteMinModifiersCheck");
            /** select only if its valid for selection */
            this.selectModifier(
              modifier.AdditionGroupId,
              addition.price,
              addition.Id,
              { modifier, addition }
            );
            this.previeusAdditionId = id;
          this.isLoading = false;
          })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    uncheck(event, id, price, modifierGroupId) {
      if (id != this.previeusAdditionId) {
        this.previeusAdditionId = id;
        this.previeusAdditionPrice = price;
      } else {
        this.previeusAdditionId = 0;
        this.previeusAdditionPrice = 0;
      }
      if (this.selectedModifiersArray.includes(id) == true) {
        event.target.checked = false;
        if (this.modifier.maxSelectedAmount == 1) {
          this.selectedModifiers = {};
        } else {
          this.selectedModifiers.splice(
            this.selectedModifiers.findIndex((el) => el.Id == id),
            1
          );
        }
        this.selectedModifiersArray.splice(
          this.selectedModifiersArray.indexOf(id),
          1
        );
        if (modifierGroupId) {
        setTimeout(() => {
          window.$eventBus.$emit("additions-selected", {
            modifierGroupId: modifierGroupId,
            comboDealId: this.modifier.combo_deal_item_id,
            selectedModifiers: this.selectedModifiers,
          });
        }, 100);
      }
    }
    },
    selectModifier(modifierGroupId, price, id, data) {
      if (data.addition.combo_deal_item_id) {
        setTimeout(() => {
          window.$eventBus.$emit("additions-selected", {
            modifierGroupId: data.modifierGroup.AdditionGroupId,
            comboDealId: this.modifier.combo_deal_item_id,
            selectedModifiers: this.selectedComboModifiers,
          });
        }, 100);
      } else if (
        (this.minModifierComboCount != this.minSelectedAdditionComboTotal &&
          this.comboDealAdditions.combogroupid ==
            this.selectedModifiers.AdditionGroupId) ||
        this.minModifierComboCount == 0 ||
        this.minModifierComboCount == this.minSelectedAdditionComboTotal ||
        !this.selectedModifiers?.Id
      ) {
        setTimeout(() => {
          window.$eventBus.$emit("additions-selected", {
            modifierGroupId: modifierGroupId,
            comboDealId: this.modifier.combo_deal_item_id,
            selectedModifiers: this.selectedModifiers,
          });
        }, 100);
      }

      this.checkAddButtonEnableStatus()
    },
    checkAddButtonEnableStatus() {
      let minTrue = 0;
      this.minModifiersCheck.map((x) => {
        if (x.continue) {
          minTrue += 1;
        }
      });

      if (this.minModifierCount == minTrue && minTrue != 0) {
        window.$eventBus.$emit("add-to-cart-button-disable", false);
      } else {
        window.$eventBus.$emit("add-to-cart-button-disable", true);
      }
      if (this.minModifierCount == 0) {
        if (this.minSelectedAddition != this.minSelectedAdditionTotal) {
          window.$eventBus.$emit("add-to-cart-button-disable", true);
        } else {
          if (
            !this.allRequiredModifersComboDeal &&
            this.minSelectedAddition == this.minSelectedAdditionTotal
          ) {
            window.$eventBus.$emit("add-to-cart-button-disable", true);
          } else {
            /**@todo check for combo deals  */
            if (this.comboDealAdditions?.combogroupid) {
              if (
                this.minModifierComboCount == this.minSelectedAdditionComboTotal
              ) {
                window.$eventBus.$emit("add-to-cart-button-disable", false);
              }
            } else {
              window.$eventBus.$emit("add-to-cart-button-disable", false);
            }
          }
        }
      }
      if (
        this.minSelectedAdditionTotal >= this.minSelectedAddition &&
        /** if sale is como then check for Min Selected Addition Combo Total */
        (!this.isComboDeal ||
          this.minModifierComboCount == this.minSelectedAdditionComboTotal)
      ) {
        window.$eventBus.$emit("add-to-cart-button-disable", false);
      }
    },

    defaultSelectedIds() {
      // generate array of current selected modifier Id's
      const t = this.defaultSelected.map(({ Addition }) => {
        return Addition && Addition.Id;
      });
      return t;
    },
    handleChangeEmit() {
      this.$emit("change", {
        additionGroup: this.modifier,
        additions: Array.isArray(this.selectedModifiers)
          ? this.selectedModifiers.map((d) => ({ Addition: d }))
          : { Addition: this.selectedModifiers },
      });
      this.checkAddButtonEnableStatus();
    },
    handleChange() {
      this.$emit("change", {
        additionGroup: this.modifier,
        additions: Array.isArray(this.selectedComboModifiers[0])
          ? this.selectedComboModifiers[0].map((d) => ({ Addition: d }))
          : { Addition: this.selectedComboModifiers[0] },
      });
      this.checkAddButtonEnableStatus();
    },
    handleSelectedChange(currentValue) {
      let allmodifiers = this.modifier.Additions.map((x) => x.Id);
      if (this.minModifiersCheck.length) {
        // if the id's are not the same we know that its the first time we click on that addition group so we put that in the array so we can hold that data
        this.minModifiersCheck.map((x) => {
          if (x.id == this.modifier.AdditionGroupId) {
            x.minCount = 0;
          } else {
            if (this.modifier.minSelectedAmount != 0) {
              this.$store.commit("updateMinModifiersCheck", {
                id: this.modifier.AdditionGroupId,
                min: this.modifier.minSelectedAmount,
                minCount: 0,
                continue: false,
              });
              // we only want to store the same items 1 time in the array so we sort them out and store them
              this.$store.commit(
                "transformMinModifiersCheck",
                _.uniqBy(this.minModifiersCheck, "id")
              );
            }
          }
        });
      } else {
        if (this.modifier.minSelectedAmount != 0) {
          this.$store.commit("updateMinModifiersCheck", {
            id: this.modifier.AdditionGroupId,
            min: this.modifier.minSelectedAmount,
            minCount: 0,
            continue: false,
          });
        }
      }
      if (this.modifier.maxSelectedAmount == 1) {
        let duplicateArray = [...this.allSelectedModifiers];
        
        const filteredObjects = duplicateArray.filter(item => item.AdditionGroupId === this.modifier.AdditionGroupId);

        const count = filteredObjects.length;
        if (count == 0) {
          duplicateArray.push(currentValue) 
        }
        else {
          duplicateArray = duplicateArray.filter(obj => obj.AdditionGroupId !== this.modifier.AdditionGroupId);
          duplicateArray.push(currentValue) 
        }

        // Get the current addition group on click
        const additions =
          document.querySelectorAll(`.allAdditions`)[this.arrayNumber];
        // get all the additions with the additionPicture class in it
        const specificAdditions = additions.querySelectorAll(
          ".AdditionItemWrapper"
        );
        // console.log(specificAdditions);
        const alreadySelected = !duplicateArray.some(obj => 
          obj.Id !== undefined && obj.Id == currentValue.Id
        );
        if (
          document.querySelectorAll(`.allAdditions`)[
            // eslint-disable-next-line no-use-before-define
            this.arrayNumber
          ].classList.contains("AdditionSelected")
        ) {
          if (!alreadySelected && this.modifier.minSelectedAmount != 1) {
            specificAdditions.forEach((s) => {
              s.classList.add("AdditionItemWrapper--closed");
              s.classList.remove("AdditionItemWrapper--open");
            });
          }
          else {
              document.querySelectorAll(`.allAdditions`)[
                // eslint-disable-next-line no-use-before-define
                this.arrayNumber
              ].classList.remove("AdditionSelected");
            specificAdditions.forEach((s) => {
                s.classList.add("AdditionItemWrapper--open");
                s.classList.remove("AdditionItemWrapper--closed");
              });
          }
        } else {
            document.querySelectorAll(`.allAdditions`)[
              // eslint-disable-next-line no-use-before-define
              this.arrayNumber
            ].classList.add("AdditionSelected");
            specificAdditions.forEach((s) => {
              if (this.isComboDeal) {
                s.classList.add("AdditionItemWrapper--open");
                s.classList.remove("AdditionItemWrapper--closed");
              }
              else {
                  s.classList.add("AdditionItemWrapper--closed");
                  s.classList.remove("AdditionItemWrapper--open");
              }
            });
        }
        document.querySelectorAll(`.allAdditions`)[
          // eslint-disable-next-line no-use-before-define
          this.arrayNumber
        ].classList.remove("required");

        let objectId = { Id: this.selectedModifiers.Id };
        if (objectId?.Id) {
          this.selectedModifiersArray = _.map(objectId, (item) => item);
          // return (this.selectedModifiersArray += this.selectedModifiers.Id);
        }
      } else {
        this.selectedModifiersArray = _.map(
          this.selectedModifiers,
          function (item) {
            return item.Id;
          }
        );
        const additions =
          document.querySelectorAll(`.allAdditions`)[this.arrayNumber];
        const specificAdditions = additions.querySelectorAll(
          ".AdditionItemWrapper"
        );
        if (this.selectedModifiersArray.length == this.modifier.maxSelectedAmount) {
          specificAdditions.forEach((s) => {
                s.classList.add("AdditionItemWrapper--closed");
                s.classList.remove("AdditionItemWrapper--open");
              });
        }
        else {
          specificAdditions.forEach((s) => {
                s.classList.add("AdditionItemWrapper--open");
                s.classList.remove("AdditionItemWrapper--closed");
              });
        }
      }
      /** Disable add to cart button disabled when minimum one modifers is allowed. */
      if (this.modifier.minSelectedAmount == 1) {
        if (this.modifier.maxSelectedAmount == 1) {
          let radioBtnCurrentValue = [currentValue];
          if (radioBtnCurrentValue.length >= this.modifier.minSelectedAmount) {
            /** perform operation only when it's not comboDeal
             * in combo deal this will be perform inside ComboAdditions component */
            if (radioBtnCurrentValue[0].Id && !this.radioButtonLength) {
              //refactor this function in later stadium / this keeps the right number of selected MIN additions
            } else {
              this.radioButtonLength = false;
              this.$store.commit(
                "updateMinSelectedAdditionTotal",
                this.minSelectedAdditionTotal - 1
              );
            }
            if (radioBtnCurrentValue[0].Id) {
              document.querySelectorAll(`.allAdditions`)[
                // eslint-disable-next-line no-use-before-define
                this.arrayNumber
              ].classList.add("AdditionSelected");
              const additions =
              document.querySelectorAll(`.allAdditions`)[this.arrayNumber];
              const specificAdditions = additions.querySelectorAll(
              ".AdditionItemWrapper"
        );
              specificAdditions.forEach((s) => {
                if (this.isComboDeal) {
                  s.classList.add("AdditionItemWrapper--open");
                  s.classList.remove("AdditionItemWrapper--closed");
                }
                else {
                  s.classList.add("AdditionItemWrapper--closed");
                  s.classList.remove("AdditionItemWrapper--open");
                }
            });
              this.radioButtonLength = true;
              this.$store.commit(
                "updateMinSelectedAdditionTotal",
                this.minSelectedAdditionTotal + 1
              );
            }
            this.modifiersMessage = "";
          } else {
            this.modifiersMessage =
              this.lang["minimum_one_item_is_required"][this.language];
          }
        } else {
          if (
            this.modifier.minSelectedAmount == 1 &&
            this.modifier.maxSelectedAmount == -1
          ) {
            if (this.selectedModifiers.length && this.updatedMinMax == false) {
              this.$store.commit(
                "updateMinSelectedAdditionTotal",
                this.minSelectedAdditionTotal + 1
              );
              this.updatedMinMax = true;
            }
            if (this.selectedModifiers.length == 0) {
              this.$store.commit(
                "updateMinSelectedAdditionTotal",
                this.minSelectedAdditionTotal - 1
              );
              this.updatedMinMax = false;
            }
          }
          if (currentValue.length >= this.modifier.minSelectedAmount) {
            if (!this.comboDealAdditions?.combogroupid) {
              this.modifiersMessage = "";
            }
          } else {
            // if not enough items are selected then block button
            this.modifiersMessage =
              this.lang["minimum_one_item_is_required"][this.language];
          }
        }
      }
      if (this.modifier.minSelectedAmount > 1) {
        if (
          this.minSelected == this.modifier.minSelectedAmount ||
          !this.minselectedbool
        ) {
          //refactor this function in later stadium / this keeps the right number of selected MIN additions
        }
        if (currentValue.length) {
          this.radioButtonLength = true;
          this.minSelected += 1;
        }
        let currentModifiers = this.selectedModifiersArray;
        let lengthModifiers = _.difference(
          allmodifiers,
          currentModifiers
        ).length;
        this.lengthModifiersDiff = allmodifiers.length - lengthModifiers;
        //updates the mincount in the array so we know how many additions we clicked
        currentValue.map((x) =>
          this.minModifiersCheck.map((y) => {
            if (y.id == x.AdditionGroupId) {
              y.minCount += 1;
            }
          })
        );
      }
      /** In Case when Unlimited Modifieres are allowed */
      if (this.modifier.maxSelectedAmount == -1) {
        this.$store.commit("updateModifierNumber", 0);
        this.modifiersMessage =
          this.lang["multiple_modifiers_can_be_selected"][this.language];
        return (this.disableModifiers = false), (this.disableBackground = "");
      }
      if (this.modifier.maxSelectedAmount == 1) {
        this.$store.commit("updateModifierNumber", 1);
        /** When one modifier is selected then disable the further selection. */
        if (currentValue.length == 1) {
          this.modifiersMessage =
            this.lang["only_one_modifier_allowed"][this.language];
          this.disableBackground = "opacity-30";
          return (this.disableModifiers = true);
        } else {
          return (this.disableModifiers = false), (this.disableBackground = "");
        }
      }
      this.$store.commit("updateModifierNumber", 0);
      return (this.disableModifiers = false), (this.disableBackground = "");
    },
  },
  mounted() {
    this.$store.commit("updateMinSelectedAddition", 0);
    this.$store.commit("updateMinSelectedAdditionTotal", 0);
    const self = this;
    this.defaultSelected.forEach(
      ({ Addition, AdditionGroup: { minSelectedAmount } }) => {
        const { AdditionGroupId, price, Id } = Addition;
        self.selectModifier(AdditionGroupId, price, Id);
        this.handleSelectedChange(Addition);
        this.selectedModifiersArray.push(Id);
        if (minSelectedAmount === 1)
          this.$store.commit(
            "updateMinSelectedAdditionTotal",
            this.minSelectedAdditionTotal + 1
          );
      }
    );
    if (this.modifier.minSelectedAmount >= 1) {
      return (this.modifiersMessage =
        this.lang["minimum_one_item_is_required"][this.language]);
    }
    if (this.modifier.maxSelectedAmount == -1) {
      this.modifiersMessage =
        this.lang["multiple_modifiers_can_be_selected"][this.language];
    }
    if (this.modifier.maxSelectedAmount == 1) {
      this.modifiersMessage =
        this.lang["only_one_modifier_allowed"][this.language];
    }
  },
};
</script>
<style scoped>
.borderNone div {
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.activeColorRadius {
  border-bottom-left-radius: 0.95rem;
  border-bottom-right-radius: 0.95rem;
}
.borderNone .checked2,
.borderNone .checkedPrice {
  border-radius: 15px;
}
.input + .checked {
  transition: all 0.3s;
}
.input + .checked img {
  transition: all 0.3s;
}
.input:checked + .checked svg,
.input:checked + div .checked2 {
  transform: rotate(45deg);
}
/* .input:checked + .checked {
  background: #95a8fa;
  opacity: 1;
} */
/* .input:checked + div {
  background: #e3e8fe;
  border-radius: 0%;
  opacity: 1;
} */
.input:checked + .extra {
  border-radius: 2rem;
}
.borderNone:first-of-type .input:checked + .extra {
  border-top-left-radius: 2rem;
  border-top-right-radius: 2rem;
}
.borderNone:last-of-type .input:checked + .extra {
  border-bottom-left-radius: 2rem;
  border-bottom-right-radius: 2rem;
}
/* .input:checked + div .checked2 {
  display: none;
} */
.input + div:hover {
  cursor: pointer;
}
.additionTitle {
  line-height: 0.1em;
}
.shadow {
  -webkit-box-shadow: 0px 0px 16px 0px rgb(0 0 0 / 8%);
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 8%);
}
.AdditionItemWrapper {
  overflow: hidden;
}
.AdditionItemWrapper,
.AdditionItemWrapper * {
  transition: all 0.5s ease-in-out;
}
.AdditionItemWrapper--open {
  overflow: hidden;
  max-height: 100vh;
}
.AdditionItemWrapper--closed {
  max-height: 0vh;
}

.required .requiredTitle {
  color: red;
  font-weight: bold;
}
.required.animated .requiredTitle {
  animation: 1.5s ease-out 0s 1 zoomInAndOut;
}
@keyframes zoomInAndOut {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.25s ease;
  position: absolute;
}
.fade-enter-from,
.fade.leave-to {
  opacity: 0;
}
</style>

<style>
.AdditionItemWrapper {
  overflow: hidden;
}
.AdditionItemWrapper,
.AdditionItemWrapper * {
  transition: all 0.5s ease-in-out;
}
.AdditionItemWrapper--open {
  overflow: hidden;
  max-height: 100vh;
}
.AdditionItemWrapper--closed {
  max-height: 0vh;
}
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }
  20%, 40%, 60%, 80% { transform: translateX(10px); }
}

.shake {
  animation: shake 0.5s;
}
</style>

